import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Divider,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Collapse
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { logout } from "../../../Requests";
import DynamicIcon from "../../DynamicIcon";
import getActiveModules from "../../../Storages/getActiveModules";
import CompetenciaStorageUtils from "../../../Storages/competenciaStorage";

const ListComponentNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathArray = location.pathname.split('/');
  const activeModules = getActiveModules();
  const [openTopics, setOpenTopics] = useState<{ [key: number]: boolean }>({});

  const handleToggle = (id: number) => {
    setOpenTopics(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleLogout = async () => {
    await logout.post();
    // Limpa a competência selecionada do localStorage quando faz logout
    CompetenciaStorageUtils.clear();
    window.location.href = '/login'; // ou navegação controlada
  };

  const isActive = (route: string) => `/${pathArray[1]}` === route;

  const mainDirect = activeModules.filter(m => m.main_menu && !m.is_topic);
  const topics = activeModules.filter(m => m.is_topic);
  const submenus = activeModules.filter(m => m.is_submenu);
  const secondary = activeModules.filter(m => !m.main_menu && !m.is_topic && !m.is_submenu);

  return (
    <List component="nav" sx={{ paddingTop: 0, background: '#1c2e4a' }}>
      <Grid>

        {/* Itens principais diretos */}
        {mainDirect.map(item => (
          <ListItemButton
            key={item.id}
            onClick={() => navigate(item.route_name)}
            selected={isActive(item.route_name)}
            sx={{
              color: '#ffffff',
              '&.Mui-selected': { backgroundColor: '#2e3a59' },
              '&:hover': { backgroundColor: '#2e3a59' }
            }}
          >
            <DynamicIcon iconName={item.icon_name} marginRight={2} />
            <ListItemText primary={item.description} />
          </ListItemButton>
        ))}

        {/* Tópicos com submenus */}
        {topics.map(topic => {
          const subItems = submenus.filter(s => s.id_topic_module === topic.id);
          const isTopicSelected = subItems.some(s => isActive(s.route_name));
          return (
            <React.Fragment key={topic.id}>
              <ListItemButton
                onClick={() => handleToggle(topic.id)}
                selected={isTopicSelected}
                sx={{
                  color: '#ffffff',
                  '&.Mui-selected': { backgroundColor: '#2e3a59' },
                  '&:hover': { backgroundColor: '#2e3a59' }
                }}
              >
                <DynamicIcon iconName={topic.icon_name} marginRight={2} />
                <ListItemText primary={topic.description} />
                {openTopics[topic.id] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openTopics[topic.id]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {subItems.map(sub => (
                    <ListItemButton
                      key={sub.id}
                      onClick={() => navigate(sub.route_name)}
                      selected={isActive(sub.route_name)}
                      sx={{
                        pl: 4,
                        color: '#ffffff',
                        '&.Mui-selected': { backgroundColor: '#3a4663' },
                        '&:hover': { backgroundColor: '#3a4663' }
                      }}
                    >
                      <DynamicIcon iconName={sub.icon_name} marginRight={2} />
                      <ListItemText primary={sub.description} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          );
        })}

        <Divider sx={{ my: 1, borderColor: '#ffffff33' }} />

        {/* Menus secundários */}
        {secondary.map(item => (
          <ListItemButton
            key={item.id}
            onClick={() => navigate(item.route_name)}
            selected={isActive(item.route_name)}
            sx={{
              color: '#ffffff',
              '&.Mui-selected': { backgroundColor: '#2e3a59' },
              '&:hover': { backgroundColor: '#2e3a59' }
            }}
          >
            <DynamicIcon iconName={item.icon_name} marginRight={2} />
            <ListItemText primary={item.description} />
          </ListItemButton>
        ))}

        <Divider sx={{ my: 1, borderColor: '#ffffff33' }} />

        {/* Botão de Logout */}
        <ListItemButton onClick={handleLogout} sx={{ color: '#ffffff' }}>
          <LogoutIcon sx={{ marginRight: 2 }} />
          <ListItemText primary="Sair" />
        </ListItemButton>

        <Divider sx={{ mt: 1, borderColor: '#ffffff33' }} />

      </Grid>
    </List>
  );
};

export default ListComponentNav;
